import { render, staticRenderFns } from "./game_wheel.vue?vue&type=template&id=4c67730c&scoped=true"
import script from "./game_wheel.vue?vue&type=script&lang=ts"
export * from "./game_wheel.vue?vue&type=script&lang=ts"
import style0 from "./game_wheel.vue?vue&type=style&index=0&id=4c67730c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67730c",
  null
  
)

export default component.exports